import { Edit } from "@mui/icons-material";
import { FormControl, Tooltip, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import HNSColors from "../../../ui library/HNSColors";

import SmartyAutoComplete from "./SmartyAutoComplete";
import { STYLES } from "./style/customStyles";

export default function AddressField({
  initialAddress,
  fieldName,
  fieldValue,
  defaultEditingMode = false,
  customOnChange,
}) {
  const [isEditing, setIsEditing] = useState(defaultEditingMode);
  const [hovered, setHovered] = useState(false);
  const [address, setAddress] = useState(fieldValue);

  useEffect(() => {
    setAddress(fieldValue ?? null);
  }, [fieldValue]);

  return (
    <FormControl variant="outlined" className="w-full">
      {isEditing ? (
        <div>
          <SmartyAutoComplete
            initialAddress={initialAddress}
            address={address}
            setAddress={(val) => {
              setAddress(val);
              customOnChange(fieldName, val ?? null);
            }}
            hideLabel={true}
            inputSx={{
              ...STYLES.addressField,
            }}
          />
        </div>
      ) : (
        <Tooltip title="Click to edit">
          <span>
            <Button
              className="flex w-full flex-row justify-between break-all bg-white text-left text-[14px] hover:bg-gray-200"
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              onClick={() => setIsEditing(true)}
              sx={{
                color: HNSColors.neutrals[100],
                borderRadius: "8px",
                transition: "border-color 0.3s",
                border: `1px solid ${!hovered ? HNSColors.secondary[500] : HNSColors.neutrals[400]}`,
              }}
            >
              <Typography className="align-left" sx={{ ...STYLES.textField }}>
                {fieldValue?.raw && fieldValue.raw.trim() !== "" ? (
                  fieldValue.raw
                ) : (
                  <span className="text-gray-400">Add Address</span>
                )}
              </Typography>
              {hovered && (
                <span>
                  <Edit className="text-gray-400" />
                </span>
              )}
            </Button>
          </span>
        </Tooltip>
      )}
    </FormControl>
  );
}
